// extracted by mini-css-extract-plugin
export default {"app":"App-module__app--BeCqZ","loading":"App-module__loading--hjgoF"};